import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CommonService } from "app/reusable/common.service";
import { CedNotificationService } from "ced-ng-library";
import { environment } from "environments/environment";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CalamityService } from "../calamity.service";

@Component({
  selector: "app-calamity-list",
  templateUrl: "./calamity-list.component.html",
  styleUrls: ["./calamity-list.component.scss"],
})
export class CalamityListComponent implements OnInit, OnDestroy {
  dataSource: any[] = [];
  private _subject$: Subject<boolean> = new Subject();
  public serverUrlSlot1 : string = environment.Services.AlphaURLSlot1;
  selectedCalamity = null;

  constructor(
    private calamityService: CalamityService,
    private cedNotificationService: CedNotificationService,
    private router: Router,
    private commonService: CommonService,
  ) {}

  ngOnInit() {
    this.getCalamities();
  }

  getCalamities() {
    this.calamityService
      .getAll()
      .pipe(takeUntil(this._subject$))
      .subscribe((data: any) => {
        this.dataSource = data;
        this.dataSource.forEach(element => {
          let GetDossierUrl: string =
            `Dossier/GetDossiersByCalamityId/` + element.calId;
          this.commonService
            .getData(GetDossierUrl, this.serverUrlSlot1)
            .pipe(takeUntil(this._subject$))
            .subscribe((res: any[]) => { 
              element.totalDossiers = res.length
            },
            (error) => {
                this.cedNotificationService.error("NOTIFICATIONS.GET_DOSSIER");
            });
        });
      });
  }

  addNewCalamity(){
    this.calamityService.setCalId(null);
    this.router.navigate(["/calamity/calamityWizard/calamityBasicDetails"]);
  }

  openDetails() {
    if(this.selectedCalamity != null)
      this.router.navigate(["/calamity/calamityWizard/calamityBasicDetails"]);
  }
 
  onCellClick($event) {
    this.selectedCalamity = $event.dataItem
    this.calamityService.setCalId($event.dataItem.calId);
  }

  deleteCalamity(event){
    this.calamityService
    .delete(event.calId)
    .pipe(takeUntil(this._subject$))
    .subscribe((data : any) => {
      this.cedNotificationService.success("NOTIFICATIONS.DATA_SAVED")      
      this.getCalamities();
    },
    (error) => {
        this.cedNotificationService.error("NOTIFICATIONS.DELETE_CALAMITY");
    });
  }

  ngOnDestroy(): void {
    this._subject$.unsubscribe();
  }
}